import { TEACHERS_ROUTE } from 'app/teachers/teachers-routing.constant';

export const SCHOOL_ROUTE = {
  name: 'school',
  route(): string[] {
    return [...TEACHERS_ROUTE.route(), this.name];
  }
};
